import { Component, Input } from '@angular/core';

@Component({
   selector: 'app-powered-by',
   templateUrl: './powered-by.component.html',
   styleUrls: ['./powered-by.component.scss']
})
export class PoweredByComponent {
   @Input() customLogo = false;

   get currentYear(): number {
      return new Date().getFullYear();
   }
}
